<script lang="ts">
    export let text = ""
</script>

<div class="placeholder">
    <h4>MODUL</h4>
    {text}
</div>

<style>
    .placeholder {
        background: #dfd4d4;
        border: 1px solid #ccc;
        padding: 1rem;
        margin: 1rem 0;
    }
</style>
